module.exports = __webpack_public_path__ + "static/media/location-king-934dcc.65155636.svg";